import React, { useContext } from 'react'
// @ts-ignore
import { Box, Button, Flex, Heading, Text } from 'rebass'
import {
  trackHandler,
  useUneeqState,
  UneeqContext,
  useDisableBodyOverflow
} from 'uneeq-react-core'
import { MayaOverlay } from '../MayaOverlay'
import { useTranslation } from 'react-i18next'
import { useSendSocketMessage } from '../../app/hooks/useSendSocketMessage'
import QuestionMark from '../MayaIcons/QuestionMark'
import { useTvContext } from '../../app/hooks/useTvContext'

interface MayaConfirmRestartProps {
  speak: boolean
}

const MayaConfirmRestart = React.memo(({ speak }: MayaConfirmRestartProps) => {
  const { confirmRestartOpen } = useUneeqState()
  const sendMessage = useSendSocketMessage()
  const { tvAppMode, symptomIds } = useTvContext()

  const sendBeginMessage = () => sendMessage({ type: 'begin' })

  const { dispatch } = useContext(UneeqContext)
  const { t } = useTranslation()

  useDisableBodyOverflow(confirmRestartOpen)

  const closeConfirmRestart = () =>
    dispatch({ type: 'mayaCloseConfirmRestart' })
  const handleConfirm = () => {
    if (tvAppMode) {
      sendMessage({
        type: 'begin',
        speak,
        symptomIds:
          Array.isArray(symptomIds) && symptomIds.length !== 0
            ? symptomIds
            : undefined
      })
    } else {
      sendBeginMessage()
    }
    closeConfirmRestart()
  }

  if (!confirmRestartOpen) return null

  return (
    <MayaOverlay>
      <Flex variant="modal">
        <Box variant="modalIconWrapper">
          <QuestionMark />
        </Box>
        <Box>
          <Heading variant="headingMedium">{t('RestartSession.title')}</Heading>
          <Text variant="content">{t('RestartSession.subtitle')}</Text>
        </Box>
        <Flex variant="modalButtons">
          <Button
            id="confirm"
            variant="secondary"
            onClick={trackHandler(handleConfirm, 'exit-session-btn')}
          >
            {t('RestartSession.confirm')}
          </Button>
          <Button
            autoFocus
            id="cancel"
            variant="primary"
            onClick={closeConfirmRestart}
          >
            {t('RestartSession.dismiss')}
          </Button>
        </Flex>
      </Flex>
    </MayaOverlay>
  )
})

export default MayaConfirmRestart
